import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {PAN, ZOOMIN, ZOOMOUT} from 'rc-canvas/lib/ZoomPanModes';
import {Button} from 'react-bootstrap';
import ZoomInIcon from './ZoomInIcon';
import ZoomOutIcon from './ZoomOutIcon';
import ZoomResetIcon from './ZoomResetIcon';
import ReactTooltip from 'react-tooltip';
import Mousetrap from 'mousetrap';

export default class ZoomPanModePicker extends Component {
    static propTypes = {
        mode: PropTypes.string,
        onModeChanged: PropTypes.func,
        onResetView: PropTypes.func,
    };

    componentDidMount() {
        const {onModeChanged, onResetView} = this.props;
        Mousetrap.bind('h', (e) => {
            e.preventDefault();
            onModeChanged(PAN);
        });

        Mousetrap.bind(['Z'], (e) => {
            e.preventDefault();
            onModeChanged(ZOOMIN);
        });

        Mousetrap.bind('z', (e) => {
            e.preventDefault();
            onModeChanged(ZOOMOUT);
        });

        Mousetrap.bind('`', (e) => {
            e.preventDefault();
            onResetView(e);
        });
    }


    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['h', 'z', 'Z', '`']);
    }

    render() {
        const {onModeChanged, onResetView, mode, ...rest} = this.props;
        const iconStyle = {height: 16, width: 16};
        return (
            <div className="zoom-pan-mode-picker">
                <div {...rest} className="zoom-pan-mode-tools btn-group btn-matrix-2">
                    <Button
                        active={mode === ZOOMIN}
                        bsStyle={mode === ZOOMIN ? 'success' : 'default'}
                        data-tip
                        data-for="zoominTooltip"
                        onClick={() => onModeChanged(ZOOMIN)}
                        bsSize="sm"
                    >
                        <ZoomInIcon style={iconStyle}/>
                    </Button>
                    <Button
                        active={mode === ZOOMOUT}
                        bsStyle={mode === ZOOMOUT ? 'success' : 'default'}
                        data-tip
                        data-for="zoomoutTooltip"
                        onClick={() => onModeChanged(ZOOMOUT)}
                        bsSize="sm"
                    >
                        <ZoomOutIcon style={iconStyle}/>
                    </Button>
                    <Button
                        active={mode === PAN}
                        bsStyle={mode === PAN ? 'success' : 'default'}
                        data-tip
                        data-for="panTooltip"
                        onClick={() => onModeChanged(PAN)}
                        bsSize="sm"
                        className="btn-pan"
                    >
                        <i className="fa fa-hand-paper-o"/>
                    </Button>
                    <Button
                        bsStyle="default"
                        data-tip
                        data-for="resetViewTooltip"
                        onClick={onResetView}
                        bsSize="sm"
                    >
                        <ZoomResetIcon style={iconStyle}/>
                    </Button>
                </div>
                <ReactTooltip id="panTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'View/Pan'}</div>
                    <kbd>{'h'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="zoominTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Zoom In'}</div>
                    <kbd>{'shift-Z'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="zoomoutTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Zoom Out'}</div>
                    <kbd>{'z'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="resetViewTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Reset View'}</div>
                    <kbd>{'`'}</kbd>
                </ReactTooltip>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ZoomPanModePicker.js